import React from "react";
import { FormattedMessage } from "react-intl";

import logoDarkModeImage from "@/assets/images/branding/truth-logo-dark.svg";
import logoImage from "@/assets/images/branding/truth-logo.svg";

const config = {
  appleAppId: 1586018825,
  authenticatedProfile: true,
  name: "Truth Social",
  logo: logoImage,
  logoDarkMode: logoDarkModeImage,
  displayFqn: false,
  displayCta: true,
  feedInjection: true,
  allowedEmoji: ["❤️", "👍", "👎", "😂", "😯", "😢", "🔥", "🎉"],
  truthPlusPlayerLink: "https://player.truthsocial.tv/start",
  extensions: {
    pepe: {
      enabled: true,
    },
    ads: {
      enabled: true,
      provider: "truth",
      algorithm: [
        "abovefold",
        {
          range: [2, 2],
          pageSize: 7,
        },
      ],
    },
  },
  emails: {
    appeals: "appeals@truthsocial.com",
  },
  links: {
    support: {
      FormattedMessage: () => (
        <FormattedMessage
          id="alert.unexpected.links.support"
          defaultMessage="Support"
        />
      ),
      fallbackMessage: "Support",
      href: "mailto:support@truthsocial.com",
    },
    status: {
      FormattedMessage: () => (
        <FormattedMessage
          id="alert.unexpected.links.status"
          defaultMessage="Status"
        />
      ),
      fallbackMessage: "Status",
      href: "https://truthsocial.statuspage.io",
    },
    help: {
      FormattedMessage: () => (
        <FormattedMessage
          id="alert.unexpected.links.help"
          defaultMessage="Help Center"
        />
      ),
      fallbackMessage: "Help Center",
      href: "https://help.truthsocial.com",
    },
    legal: {
      terms: {
        FormattedMessage: () => (
          <FormattedMessage
            id="registration.tos"
            defaultMessage="Terms of Service"
          />
        ),
        href: "https://help.truthsocial.com/legal/terms-of-service",
      },
      privacy: {
        FormattedMessage: () => (
          <FormattedMessage
            id="registration.privacy"
            defaultMessage="Privacy Policy"
          />
        ),
        href: "https://help.truthsocial.com/legal/privacy-policy",
      },
      cookies: {
        FormattedMessage: () => (
          <FormattedMessage
            id="registration.cookies"
            defaultMessage="Cookie Policy"
          />
        ),
        href: "https://help.truthsocial.com/legal/cookie-policy",
      },
    },
  },
  navlinks: {
    homeFooter: [
      {
        title: "CCPA Privacy Policy",
        url: "https://help.truthsocial.com/legal/ccpa-privacy-policy",
      },
      {
        title: "Advertise",
        url: "/advertising",
      },
      {
        title: "Help Center",
        url: "https://help.truthsocial.com",
      },
      {
        title: "Open Source",
        url: "https://help.truthsocial.com/legal/open-source",
      },
    ],
  },
  redirectRootNoLogin: "",
};

export { config };
